export const PHONE_NUMBER = "+54 9 3815783030";

export const WHATSAPP_LINK_URL = `https://wa.me/${PHONE_NUMBER.replace(/\D/g, "")}`;
